import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const addIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 0a3.048 3.048 0 0 1 3.027 2.692l.02.356v25.904h25.905a3.048 3.048 0 0 1 .356 6.075l-.356.02H35.048v25.905a3.048 3.048 0 0 1-6.075.356l-.02-.356V35.048H3.047a3.048 3.048 0 0 1-.356-6.075l.356-.02h25.904V3.047A3.048 3.048 0 0 1 32 0Z" fill-rule="evenodd"/></svg>`
);
